import type { OperationalAlertInput } from "@/types/operational-alert";

export const OPERATIONAL_ALERT_PUBLISH_EVENT =
  "epitrack:operational-alert:publish";
export const OPERATIONAL_ALERT_CLEAR_OPERATION_EVENT =
  "epitrack:operational-alert:clear-operation";
export const OPERATIONAL_ALERT_CLEAR_ALL_EVENT =
  "epitrack:operational-alert:clear-all";

export function publishOperationalAlert(alert: OperationalAlertInput) {
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent<OperationalAlertInput>(OPERATIONAL_ALERT_PUBLISH_EVENT, {
        detail: alert,
      }),
    );
  }
}

export function clearOperationalAlertsForOperation(operationKey: string) {
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent<string>(OPERATIONAL_ALERT_CLEAR_OPERATION_EVENT, {
        detail: operationKey,
      }),
    );
  }
}

export function clearAllOperationalAlerts() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(OPERATIONAL_ALERT_CLEAR_ALL_EVENT));
  }
}
